import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, FileText, HeartPulse, Pill, Activity, Moon, Utensils } from 'lucide-react';

const factors = [
  { icon: FileText, text: 'Medical history and laboratory reports' },
  { icon: Pill, text: 'Current medications' },
  { icon: HeartPulse, text: 'Blood glucose, HbA1c, blood pressure and lipids' },
  { icon: Activity, text: 'Body composition and activity level' },
  { icon: Moon, text: 'Sleep, stress and daily routine' },
  { icon: Utensils, text: 'Dietary preferences and real-life schedule' },
];

const NotGenericSection = () => (
  <section id="not-generic" className="py-16 sm:py-20 lg:py-24 relative overflow-hidden bg-slate-950" data-testid="not-generic-section">
    <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-blue-600/10 rounded-full blur-3xl" aria-hidden="true"></div>
    <div className="container mx-auto px-4 sm:px-6 relative z-10">
      <div className="max-w-3xl mx-auto text-center mb-10 sm:mb-14">
        <span className="inline-flex items-center gap-2 px-4 py-2 bg-orange-500/10 border border-orange-500/30 rounded-full text-orange-400 text-sm font-medium mb-4">
          The TCUBE Difference
        </span>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
          Not Another <span className="bg-gradient-to-r from-blue-400 via-orange-400 to-emerald-400 bg-clip-text text-transparent">Generic Diet Plan</span>
        </h2>
        <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
          A generic plan tells you what to eat. A medically informed, personalized approach considers the person behind the numbers. Unlike generic fitness coaching, TCUBE FITNESS combines medical expertise with personalized nutrition and fitness guidance.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
        {factors.map((f, i) => (
          <div key={i} className="flex items-start gap-3 bg-slate-900/60 border border-slate-800 rounded-2xl p-5" data-testid={`not-generic-factor-${i}`}>
            <span className="w-10 h-10 rounded-xl bg-slate-800/80 border border-slate-700 flex items-center justify-center text-emerald-400 flex-shrink-0">
              <f.icon className="w-5 h-5" aria-hidden="true" />
            </span>
            <p className="text-slate-300 text-sm sm:text-base leading-relaxed pt-1.5">{f.text}</p>
          </div>
        ))}
      </div>

      <div className="text-center mt-10">
        <Link
          to="/health-analysis"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-500 hover:to-cyan-500 text-white px-7 py-3.5 rounded-full font-bold text-sm sm:text-base transition-all shadow-lg shadow-blue-500/25"
          data-testid="not-generic-cta"
        >
          Start With Your Full Body Health Analysis
          <ArrowRight className="w-4 h-4" aria-hidden="true" />
        </Link>
      </div>
    </div>
  </section>
);

export default NotGenericSection;
